import { ChevronDown, ChevronRight, Lightbulb } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  content: string;
  streaming?: boolean;
}

export function ThinkingBlock({ content, streaming = false }: Props) {
  const { t } = useTranslation("threads");
  const [open, setOpen] = useState(false);
  return (
    <div className="my-2 rounded-md border border-dashed bg-muted/30 p-2 text-xs">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1 text-muted-foreground"
      >
        {open ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        <Lightbulb className="h-3 w-3" />
        <span>{t("blocks.thinking")}{streaming ? "..." : ""}</span>
      </button>
      {open ? (
        <pre className="mt-1 max-h-60 overflow-auto whitespace-pre-wrap font-mono">
          {content}
        </pre>
      ) : null}
    </div>
  );
}
